import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useTimesheetFlow } from "@/features/timesheetFlow/useTimesheetFlow";

/**
 * Öffnet den Stundennachweis-Detail bei `?timesheet_id=` und entfernt den Parameter danach.
 */
export function useTimesheetDeepLink() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { openDetail } = useTimesheetFlow();

  useEffect(() => {
    const raw = searchParams.get("timesheet_id");
    if (!raw) return;
    const id = Number(raw);
    if (!Number.isFinite(id) || id <= 0) return;

    openDetail(id);
    const next = new URLSearchParams(searchParams);
    next.delete("timesheet_id");
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams, openDetail]);
}
